import React from 'react';
import PropTypes from 'prop-types';

import styles from './DiscountTagRebrand.module.css';

const DiscountTagRebrand = ({
  discountPercent,
  className = ''
}) => {
  if (!discountPercent || discountPercent <= 0) {
    return null;
  }

  return (
    <div
      className={`
        ${styles.discountTag}
        ${className}
      `}
    >
      Save up to
      {' '}
      {discountPercent}
      %
    </div>
  );
};

DiscountTagRebrand.propTypes = {
  discountPercent: PropTypes.number.isRequired,
  className: PropTypes.string
};

DiscountTagRebrand.defaultProps = {
  className: ''
};

export default DiscountTagRebrand;
